import React, { Component } from 'react'
import Timer from './timer/timer'
import Scoreboard from './scoreboard/scores'
import { white, blue, SCORES, FIGHTERS } from './constants'
import styled from 'styled-components'
import Osaekomi from './osaekomi'
import mp3_file from './boxing_bell.mp3'
import Sona from 'sona'

const Button = styled.div`
  position: absolute;
  padding: 3px 0 0 10px;
  font-size: 2.2vh;
  color: rgba(0, 0, 0, 0.45);
  cursor: pointer;
`

const Center = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`

const Top = styled.div`
  width: 100%;
  background-color: #ffc107;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  transition: 1s;
  box-shadow: 0 3px 8px -8px rgba(0, 0, 0, 0.2);
  .time {
    justify-self: center;
  }
`

const Scoreboards = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

const Body = styled.div`
  user-select: none;
`

class App extends Component {
  constructor(props) {
    super(props)

    this.sona = new Sona([{ url: mp3_file, id: 'bell' }])
    this.sona.load(() => console.log('Sound loaded'))

    this.params = new URLSearchParams(window.location.search)
    this.fightTime = this.params.has('time')
      ? this.params.get('time') * 60
      : 4 * 60

    this.state = {
      ...this.defaultState,
      time: this.fightTime
    }
  }

  countdownSpeed = 1000

  defaultState = {
    [white]: {
      IPPON: 0,
      WAZARI: 0,
      SHIDO: 0
    },
    [blue]: {
      IPPON: 0,
      WAZARI: 0,
      SHIDO: 0
    },
    winner: '',
    time: this.fightTime,
    timer: null,
    timeOn: false,
    osaekomiTime: 0,
    osaekomiTimer: null,
    osaekomiOn: false,
    osaekomiFighter: '',
    goldenScore: false
  }

  toggleTime = () => {
    if (this.state.timeOn) {
      this.stopTime()
      this.stopOsaekomiTime()
    } else {
      this.resetOsaekomiTime()
      this.startTime()
    }
  }

  stopTime = () => {
    clearInterval(this.state.timer)
    this.setState({ timeOn: false })
  }

  startTime = () => {
    const { time, goldenScore, winner } = this.state

    if (!winner) {
      // If there is a winner the time should not be start able
      if (time > 0 && !goldenScore) {
        // To make visual feedback when the time start we count down when the time is pressed
        this.setState({ time: time - 1 })
      } else if (goldenScore) {
        this.setState({ time: time + 1 })
      }

      let timer = setInterval(() => {
        const time = this.state.time

        if (time === 0 && !this.state.goldenScore) {
          this.stopTime()
          this.findWinner()
        } else if (this.state.goldenScore) {
          this.setState({ time: time + 1 })
        } else if (time === 1 && !this.state.goldenScore) {
          // To make the bell sound look like it comes at 0
          this.sona.play('bell')
          this.setState({ time: time - 1 })
        } else {
          this.setState({ time: time - 1 })
        }
      }, this.countdownSpeed)
      this.setState({ timer: timer, timeOn: true })
    }
  }

  toggleOsaekomi = () => {
    if (this.state.osaekomiOn) {
      this.stopOsaekomiTime()
    } else {
      this.startOsaekomiTime()
    }
  }

  stopOsaekomiTime = () => {
    clearInterval(this.state.osaekomiTimer)
    this.setState({ osaekomiOn: false })
  }

  resetOsaekomiTime = () => {
    clearInterval(this.state.osaekomiTimer)
    this.setState({ osaekomiOn: false, osaekomiTime: 0 })
  }

  startOsaekomiTime = () => {
    this.setState({ osaekomiTime: 0 })

    let timer = setInterval(() => {
      const time = this.state.osaekomiTime

      if (time === 9) {
        console.log('Somebody got a wazari')
      }

      if (time === 19) {
        this.sona.play('bell')
      }

      if (time === 20) {
        this.stopTime()
        console.log('Somebody won')
        this.findWinner()
        clearInterval(this.state.osaekomiTimer)
      } else {
        this.setState({ osaekomiTime: time + 1 })
      }
    }, this.countdownSpeed)
    this.setState({ osaekomiTimer: timer, osaekomiOn: true })
  }

  reset = () => {
    this.stopTime()
    this.stopOsaekomiTime()
    this.setState({
      ...this.defaultState,
      time: this.fightTime
    })
  }

  increment = (fighter, score) => {
    if (this.state.goldenScore) {
      if (score === SCORES.SHIDO) {
        this.setLooser(fighter)
      } else {
        this.setWinner(fighter)
      }
    }
    if (score === SCORES.IPPON && this.state[fighter][SCORES.IPPON] === 0) {
      this.incrementScore(fighter, score)
      this.setWinner(fighter)
    } else if (score === SCORES.WAZARI) {
      this.incrementWazari(fighter)
    } else if (score === SCORES.SHIDO) {
      this.incrementShido(fighter)
    }
  }

  incrementWazari = fighter => {
    const currentWazari = this.state[fighter][SCORES.WAZARI]

    switch (currentWazari) {
      case 0:
        this.incrementScore(fighter, SCORES.WAZARI)
        break
      case 1:
        this.wazariToIppon(fighter)
        this.setWinner(fighter)
        break
      default:
        break
    }
  }

  incrementShido = fighter => {
    const currentShido = this.state[fighter][SCORES.SHIDO]

    if (currentShido <= 1) {
      this.incrementScore(fighter, SCORES.SHIDO)
    } else if (currentShido === 2) {
      this.incrementScore(fighter, SCORES.SHIDO)
      this.increment(this.getCompetitor(fighter), SCORES.IPPON)
      this.setLooser(fighter)
    }
  }

  incrementScore = (fighter, score) => {
    const currentScore = this.state[fighter][score]
    const newScore = {
      [fighter]: {
        ...this.state[fighter],
        [score]: currentScore + 1
      }
    }

    this.setState({
      ...newScore
    })
  }

  wazariToIppon = fighter => {
    const newScore = {
      [fighter]: {
        ...this.state[fighter],
        [SCORES.IPPON]: 1,
        [SCORES.WAZARI]: 0
      }
    }

    this.setState({
      ...newScore
    })
  }

  decrement = (fighter, score) => {
    if (this.state.goldenScore) {
      this.removeWinner()
    }

    const currentScore = this.state[fighter][score]
    if (
      score === SCORES.IPPON ||
      (score === SCORES.WAZARI && currentScore === 2)
    ) {
      this.removeWinner()
    }

    if (score === SCORES.SHIDO && currentScore === 3) {
      this.decrement(this.getCompetitor(fighter), SCORES.IPPON)
      this.removeWinner()
    }

    if (currentScore > 0) {
      const newScore = {
        [fighter]: {
          ...this.state[fighter],
          [score]: currentScore - 1
        }
      }
      this.setState({
        ...newScore
      })
    }
  }

  findWinner = () => {
    const { WHITE, BLUE, osaekomiOn } = this.state

    if (!osaekomiOn) {
      if (WHITE.WAZARI > BLUE.WAZARI) {
        this.setWinner(white)
      } else if (BLUE.WAZARI > WHITE.WAZARI) {
        this.setWinner(blue)
      } else {
        this.setState({ goldenScore: true })
      }
    }
  }

  removeWinner = () => {
    this.setState({ winner: '' })
  }

  getCompetitor = fighter =>
    fighter === FIGHTERS.WHITE ? FIGHTERS.BLUE : FIGHTERS.WHITE

  setLooser = fighter => {
    if (fighter === white) {
      this.setWinner(blue)
    } else if (fighter === blue) {
      this.setWinner(white)
    } else {
      console.log(
        'Something went wrong, could not choose the right looser/winner'
      )
    }
    this.sona.play('bell')
  }

  setWinner = fighter => {
    this.stopTime()
    this.setState({ winner: fighter })
    console.log('And the winner is ' + fighter)
    this.sona.play('bell')
  }

  render() {
    return (
      <Body onClick={() => console.log('wee')}>
        <div onKeyDown={this.handleKeyPress} />
        <Button onClick={this.reset}>Reset</Button>
        <Center>
          <Top>
            <Timer
              className="time"
              toggleTime={this.toggleTime}
              time={this.state.time}
              osaekomi={this.state.osaekomiOn}
              goldenScore={this.state.goldenScore}
            />

            <Osaekomi
              toggleTime={this.toggleOsaekomi}
              time={this.state.osaekomiTime}
              timeOn={this.state.osaekomiOn}
              reset={this.resetOsaekomiTime}
            />
          </Top>
          <Scoreboards>
            <Scoreboard
              increment={this.increment}
              decrement={this.decrement}
              scores={this.state[white]}
              fighter={white}
              winner={this.state.winner}
            />
            <Scoreboard
              increment={this.increment}
              decrement={this.decrement}
              scores={this.state[blue]}
              fighter={blue}
              winner={this.state.winner}
            />
          </Scoreboards>
        </Center>
      </Body>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.jsx